// cp-alert.component.ts
import { Component } from '@angular/core';
import { AlertComponent } from '@shared/components';

@Component({
  selector: 'app-cp-alert',
  standalone: true,
  imports: [AlertComponent],
  template: `
    <div class="app-alert app-alert--warning mb-xxxl">
      <span class="app-alert__icon fa-regular fa-circle-info"></span>
      The allowable amount of spread is 0% to 10%.
    </div>

    <!-- Shared component examples -->
    <app-alert type="success" message="Changes saved successfully" title="Success" />
    <app-alert type="warning" message="Please review your input values" title="Warning" />
    <app-alert type="error" message="Unable to process request" title="Error" />
    <app-alert type="info" message="New features are available" title="Information" />
    <app-alert
      type="info"
      message="Lorem ipsum dolor sit amet consectetur, adipisicing elit. Magni voluptas veniam dolorem itaque unde corporis reiciendis, adipisci molestiae quam, mollitia delectus dolorum dolore ipsam voluptatum, veritatis repudiandae deleniti obcaecati perferendis!"
      title="Information"
    />
  `,
})
export class CpAlertComponent {}
